
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class Tips extends Vue {
  @Prop(Boolean) offers!: boolean;
  @Prop(Number) count!: number;
}
